module.exports = __webpack_public_path__ + "img/kali_1.bc43bcb5.png";